import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setAddedDevices, setRemovedDevices } from '#action/project/devices-popup';
import { getSymmetricDifference, getDeviceDiff } from '#component/device/devices-popup/helper';

export const useFloatDevicesSync = (
  formDataObj,
  openedFromForm,
  addMode,
  setReadyToFetch,
  renderRef,
  emptyForm
) => {
  const { formDevices } = useSelector(s => s.projectDevicesPopup, shallowEqual);
  const { projectId } = formDataObj;

  const dispatch = useDispatch();
  const formInitialValues = formDataObj?.initialFormDevices;

  useEffect(() => {
    if (!openedFromForm || !projectId || emptyForm) {
      return setReadyToFetch(true);
    }

    if (!formInitialValues || !formDevices.length || (addMode && renderRef.current)) {
      return false;
    }

    const symmetricDiff = getSymmetricDifference(formDevices, formInitialValues);
    const isDevicesWasReplaced = formDevices?.length === formInitialValues?.length &&
      symmetricDiff.length;

    if (isDevicesWasReplaced && !addMode) {
      const devicesDiff = getDeviceDiff(formDevices, formInitialValues);
      const diffWithSymmetric = getDeviceDiff(symmetricDiff, devicesDiff);

      if (devicesDiff.length) {
        dispatch(setAddedDevices(devicesDiff));
      }

      if (diffWithSymmetric.length) {
        dispatch(setRemovedDevices(diffWithSymmetric));
      }
    } else {
      const addedDevices = getDeviceDiff(formDevices, formInitialValues);
      const removedDevices = getDeviceDiff(formInitialValues, formDevices);

      if (addedDevices.length) {
        dispatch(setAddedDevices(addedDevices));
      }

      if (removedDevices.length) {
        dispatch(setRemovedDevices(removedDevices));
      }
    }

    return setReadyToFetch(true);
  }, [
    addMode,
    dispatch,
    projectId,
    formDevices,
    openedFromForm,
    setReadyToFetch,
    formInitialValues,
    renderRef,
    emptyForm
  ]);
};
